import * as React from 'react'
import { cn } from '../../lib/utils'

const ListItem = React.forwardRef<React.ElementRef<'a'>, React.ComponentPropsWithoutRef<'a'>>(({ className, title, children, ...props }, ref) => {
    return (
        <li>
            <a
                ref={ref}
                className={cn('hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors', className)}
                {...props}>
                <div className="text-sm font-medium leading-none">{title}</div>
                <p className="text-muted-foreground line-clamp-2 text-sm leading-snug">{children}</p>
            </a>
        </li>
    )
})
ListItem.displayName = 'ListItem'

export { ListItem }
